import type { ApplyPromoCodeParsedResponse } from "webApp";
import type { ApplyPromoCodeResponse } from "wagAPI";
export const applyPromoCodeResponseParser = ({
  balance,
  referringWalkerId
}: ApplyPromoCodeResponse): ApplyPromoCodeParsedResponse => ({
  referringWalkerId,
  balance
});
export default applyPromoCodeResponseParser;